import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_URL from '../constants.js';
import { logout } from './authSlice';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { toast } from 'react-toastify';

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: async (headers, { getState }) => {
    const firebaseUser = auth.currentUser;
    if (firebaseUser) {
      const token = await firebaseUser.getIdToken(); // always fresh token
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

let isLoggingOut = false;

const baseQueryWithAuthCheck = async (args, api, extraOptions) => {

  // Stop ALL API calls during logout
  if (isLoggingOut) {
    return { error: { status: 'LOGGING_OUT', data: null } };
  }

  const result = await baseQuery(args, api, extraOptions);

  // Firebase ID token expired → backend returns 401 → auto-logout
  if (result?.error?.status === 401) {

    if (!isLoggingOut) {
      isLoggingOut = true;
      toast.error("Your session expired. Please login again.", {autoClose: 2000});
      api.dispatch(apiSlice.util.invalidateTags([]));
      try {
        await signOut(auth);  // logout from Firebase
      } catch (err) {
        console.error("Firebase signout error:", err);
      }

      api.dispatch(logout());
      localStorage.removeItem('userInfo');
      
      setTimeout(() => {
        isLoggingOut = false;
        window.location.href = '/';
      }, 2000); // go home
    }

    return { error: {status: 401} };
  }

  return result;
};

const apiSlice = createApi({
    baseQuery: baseQueryWithAuthCheck,
    credentials: 'include',
    tagTypes: [
        'Product',
        'Order',
        'User',
        'Address',
        'Sms',
        'Email',
        'WhatsAppMessage',
        'Review'
    ],
    endpoints: () => ({})
})

export { apiSlice };